import { ColumnConfig } from "types/bankStatements";

export const insurerReportColumnConfig: ColumnConfig[] = [
  {
    columnId: "ordinalNumber",
    width: 50,
    reorderable: false,
    resizable: true,
    label: "",
    cellType: "ordinalnumber",
    sortable: false,
  },
  {
    columnId: "select",
    width: 40,
    reorderable: false,
    resizable: false,
    label: "",
    cellType: "select",
    sortable: false,
    additionalInfo: {
      rowIdField: "insurerReportId",
    },
  },
  {
    columnId: "insurerReportNumber",
    width: 150,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurerReportNumber.label",
    cellType: "customtext",
  },
  {
    columnId: "insurerName",
    width: 160,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurer.label",
    cellType: "customtext",
    additionalInfo: {
      gosLink: {
        idField: "insurerId",
        linkType: "insurer",
      },
    },
  },
  {
    columnId: "insurerReportDateFormatted",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurerReportDate.label",
    cellType: "customtext",
  },
  {
    columnId: "companyName",
    width: 150,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.grecoCompanyNumber.label",
    cellType: "customtext",
  },
  {
    columnId: "currencyCode",
    width: 80,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.currency.label",
    cellType: "taxonomy",
    additionalInfo: {
      taxonomy: "Currency",
    },
  },
  {
    columnId: "premiumAmountSum",
    width: 120,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.premiumAmount.label",
    cellType: "customnumber",
  },
  {
    columnId: "commissionAmountSum",
    width: 120,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.commissionAmount.label",
    cellType: "customnumber",
  },
  {
    columnId: "reportNetsum",
    width: 120,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.reportNet.label",
    cellType: "customnumber",
    additionalInfo: {
      // the payment to the insurer is an outgoing (negative) bank statement entry amount,
      // so the report NET sum is compared with its absolute value
      redColorFn: (report) =>
        report["insurerReportPaymentAmount"] !== null &&
        report["insurerReportPaymentAmount"] !== undefined &&
        Math.abs(report["insurerReportPaymentAmount"]) !==
          Math.abs(report["reportNetsum"]),
    },
  },
  {
    columnId: "insurerReportPaymentDateFormatted",
    width: 110,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurerReportPaymentDate.label",
    cellType: "customtext",
  },
  {
    columnId: "insurerReportPaymentAmount",
    width: 130,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.insurerReportPaymentAmount.label",
    cellType: "customnumber",
  },
  // counts of the non-deleted entries (master/detail: the entries themselves are
  // loaded only for the selected report)
  {
    columnId: "entryCount",
    width: 70,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.entryCount.label",
    cellType: "customnumber",
    additionalInfo: { fractionDigits: 0 },
  },
  {
    columnId: "matchedEntryCount",
    width: 90,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.matchedEntryCount.label",
    cellType: "customnumber",
    additionalInfo: { fractionDigits: 0 },
  },
  {
    columnId: "unmatchedEntryCount",
    width: 100,
    reorderable: true,
    resizable: true,
    sortable: true,
    label: "pct.unmatchedEntryCount.label",
    cellType: "customnumber",
    additionalInfo: {
      fractionDigits: 0,
      // entries the insurer reported but PCT could not link to a payment / installment
      redColorFn: (report) => report["unmatchedEntryCount"] > 0,
    },
  },
  {
    columnId: "options",
    width: 110,
    reorderable: true,
    resizable: true,
    sortable: false,
    label: "pct.options.label",
    cellType: "insurerreportoptions",
    additionalInfo: {
      rowIdField: "insurerReportId",
      linkField: "insurerReportDocumentPath",
    },
  },
];
